import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as collections from '../collections/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import PromptCollectionsList from './PromptCollectionsList';
import { aiPromptValidationSchema } from './utils';
import LoadingCard from './LoadingCard';
export class DefaultPage extends Component {
  static propTypes = {
    aiPromptBuilder: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  handleSubmit = async (values, { setSubmitting }) => {
    if (!values.aiPrompt) return;

    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    const { REACT_APP_AI_MODEL, REACT_APP_API_KEY } = process.env;

    const data = {
      userPrompt: values.aiPrompt,
      generatedCodeConfig: 'create_project_specific_collection',
      codeGenerationModel: '',
      apiKey: REACT_APP_API_KEY,
      aiModel: REACT_APP_AI_MODEL,
      projectId,
      version,
      isProjectSpecificCollections: true,
    };

    try {
      await actions.collectionsWithPrompt(data);
    } catch (error) {
      console.error('❌ Prompt submit error:', error);
    } finally {
      setSubmitting(false);
    }
  };

  render() {
    const { aiPromptBuilder, match, history } = this.props;
    const { projectId, version } = match.params;
    const { collectionsWithPromptPending, promptCollections = {} } = aiPromptBuilder;
    const { userPrompt = '', genCollections = [] } = promptCollections;
    const [{ collectionsList = [] } = {}, { rolesList = [] } = {}] = genCollections || [];
    const isLoading = collectionsWithPromptPending;
    if (isLoading) {
      return (
        <LoadingCard
          headerText="Creating Collections for Your Application"
          loadingText=" Please wait while we are generating collections for your application..."
          loadingFlag={isLoading}
          headerIcon="aiModelConfig"
        />
      );
    }
    if (collectionsList.length > 0) {
      return (
        <PromptCollectionsList
          promptCollections={collectionsList}
          projectId={projectId}
          version={version}
          history={history}
          userPrompt={userPrompt}
          rolesList={rolesList}
        />
      );
    }

    return (
      <CommonPageComponent>
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
            <ParentContentCard title="Create Application using AI Prompt" icon="aiModelConfig">
              <div className="center-div">
                <div className="container ml-0">
                  <h5 style={{ textTransform: 'none' }}>
                    In this onboarding process, you can build your application using AI-powered
                    prompts. Just describe your application idea in plain English, and we'll convert
                    it into code automatically.
                  </h5>
                  <h5 className="mb-5" style={{ textTransform: 'none' }}>
                    For example, you can enter: <i>"Create a project management tool."</i>
                  </h5>
                  <h5 className="mb-4" style={{ textTransform: 'none' }}>
                    Once you enter an idea, we'll automatically generate the necessary data
                    collections. You can review the generated collections and make any adjustments
                    (if necessary).
                  </h5>
                </div>
              </div>

              <Formik
                initialValues={{ aiPrompt: '' }}
                validationSchema={aiPromptValidationSchema}
                onSubmit={this.handleSubmit}
              >
                {({ isSubmitting }) => (
                  <Form>
                    <div className="form-group ml-5 mr-5 mt-4">
                      <Field
                        as="textarea"
                        name="aiPrompt"
                        rows="5"
                        placeholder="Describe your application idea here..."
                        style={{
                          width: '100%',
                          borderRadius: '15px',
                          padding: '15px',
                          fontSize: '1rem',
                          resize: 'vertical',
                          backgroundColor: '#f8f9fa',
                          border: '1px solid #ccc',
                          boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)',
                          transition: 'all 0.3s ease-in-out',
                        }}
                      />
                      <ErrorMessage name="aiPrompt" component="p" className="text-danger mt-1" />
                    </div>

                    <div className="text-right mt-3 mr-5">
                      <button
                        type="submit"
                        className="btn btn-theme-submit btn-md"
                        disabled={isSubmitting || collectionsWithPromptPending}
                        title="Submit Prompt"
                      >
                        <i className="wb webconnect-rocket"></i> &nbsp;Generate App
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </ParentContentCard>
          </div>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    aiPromptBuilder: state.aiPromptBuilder,
    collections: state.collections,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    collections: bindActionCreators({ ...collections }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
